export const notificationTypes = {
  coHostRequest: 'CO_HOST_REQUEST'
};